export default __webpack_public_path__ + "static/media/icon_4.8b3d5f53.svg";